// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_botaoNovo__HWn9O {
    width: 100% !important;
    background-color: #0f2047 !important;
    color: #ffffff !important;
    border-color: #ffffff !important;
    border-width: 1px !important;
    border-style: solid !important;
    font-family: "Inter" !important;
    font-size: 16px !important;
    margin-top: 8px !important;
    margin-bottom: 8px !important;
    border-radius: 8px !important;
    transition: all 0.3s ease !important;
    text-transform: capitalize !important;
    height: 36px !important;
  }
  
  .styles_botaoNovo__HWn9O:hover {
    transform: scale(0.95) !important;
  }`, "",{"version":3,"sources":["webpack://./src/components/ExportExcelConciliacao/styles.module.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,oCAAoC;IACpC,yBAAyB;IACzB,gCAAgC;IAChC,4BAA4B;IAC5B,8BAA8B;IAC9B,+BAA+B;IAC/B,0BAA0B;IAC1B,0BAA0B;IAC1B,6BAA6B;IAC7B,6BAA6B;IAC7B,oCAAoC;IACpC,qCAAqC;IACrC,uBAAuB;EACzB;;EAEA;IACE,iCAAiC;EACnC","sourcesContent":[".botaoNovo {\n    width: 100% !important;\n    background-color: #0f2047 !important;\n    color: #ffffff !important;\n    border-color: #ffffff !important;\n    border-width: 1px !important;\n    border-style: solid !important;\n    font-family: \"Inter\" !important;\n    font-size: 16px !important;\n    margin-top: 8px !important;\n    margin-bottom: 8px !important;\n    border-radius: 8px !important;\n    transition: all 0.3s ease !important;\n    text-transform: capitalize !important;\n    height: 36px !important;\n  }\n  \n  .botaoNovo:hover {\n    transform: scale(0.95) !important;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"botaoNovo": `styles_botaoNovo__HWn9O`
};
export default ___CSS_LOADER_EXPORT___;
